import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  addNonProfitProvider,
  hideNonProfitProviders,
} from "@services/nonProfits/services";
import { type IAddNonProfitProviderParams } from "@services/nonProfits/types";
import type { IOverviewJointBillService } from "@services/overview/types";
import { queryClient } from "@/queryClient";

export const useHideNonProfitProvidersMutation = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => hideNonProfitProviders(jointBillServiceId),
    onSuccess: () =>
      void queryClient.setQueryData(
        ["nonProfitProviders", jointBillServiceId],
        () => [],
      ),
  });
};

export const useAddNonProfitProviderMutation = (
  params: Pick<
    IAddNonProfitProviderParams,
    "jointBillServiceId" | "serviceProviderId" | "periodId"
  >,
) => {
  return useMutation({
    mutationFn: (
      serviceParams: Pick<
        IAddNonProfitProviderParams,
        "amount" | "personalCode"
      >,
    ) => addNonProfitProvider({ ...params, ...serviceParams }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["nonProfitProviders", params.jointBillServiceId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["jointBillServicePeriodData", params.jointBillServiceId],
        }),
      ]);
    },
  });
};
